module.exports = __webpack_public_path__ + "img/team-person-2.23711e45.png";